import api from '@/api/axios';

export default {
  namespaced: true,
  state: {
    dashboardData: null,
    itemStats: null,
    isLoading: false,
    isItemLoading: false
  },
  mutations: {
    SET_DASHBOARD_DATA(state, data) {
      state.dashboardData = data;
    },
    SET_ITEM_STATS(state, data) {
      state.itemStats = data;
    },
    SET_LOADING(state, status) {
      state.isLoading = status;
    },
    SET_ITEM_LOADING(state, status) {
      state.isItemLoading = status;
    }
  },

  actions: {
    async fetchDashboardData({ commit, dispatch }, payload) {
      commit('SET_LOADING', true);
      try {
        const { period, startDate, endDate } = payload;

        const response = await api.get('/reports/dashboard', {
          params: { 
            period: period,
            startDate: startDate,
            endDate: endDate
          }
        });
        commit('SET_DASHBOARD_DATA', response.data);
      } catch (error) {
        dispatch('ui/notify', {
          message: 'Falha ao carregar dados do dashboard.',
          color: 'error'
        }, { root: true });
        console.error('Erro fetchDashboardData:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchItemAnalysis({ commit, dispatch }, { id, itemType, period, startDate, endDate }) {
      commit('SET_ITEM_LOADING', true);
      try {
        const response = await api.get('/reports/item-analysis', {
          params: { id, itemType, period, startDate, endDate }
        });
        commit('SET_ITEM_STATS', response.data);
        return response.data;
      } catch (error) {
        commit('SET_ITEM_STATS', null);
        dispatch('ui/notify', {
          message: 'Nenhuma venda encontrada ou falha ao buscar item.',
          color: 'warning'
        }, { root: true });
        console.error('Erro fetchItemAnalysis:', error);
      } finally {
        commit('SET_ITEM_LOADING', false);
      }
    }
  }
};